import { gql } from 'apollo-angular';

export const deleteDraftOperationMutation = gql`
  mutation deleteDraftOperation($operationId: Int!) {
    deleteDraftOperation(operationId: $operationId)
  }
`;
